import {
  AppointmentStatusCode,
  SettlementStatus
} from "@libs/gateways/booking/BookingGateway.dtos.ts";

export type AppointmentFilterStatus =
  | AppointmentStatusCode
  | SettlementStatus
  | ClinicalStatus
  | BillingStatus;

export enum BillingStatus {
  Unbilled = "UNBILLED"
}

export enum ClinicalStatus {
  incompleteNotes = "DN"
}

const completedTypes = [
  AppointmentStatusCode.Finalised,
  AppointmentStatusCode.Completed
];

export const apptTypes = [
  AppointmentStatusCode.Booked,
  AppointmentStatusCode.Waiting,
  AppointmentStatusCode.WithProvider,
  AppointmentStatusCode.Finalised,
  AppointmentStatusCode.Completed
];

export const combinedTypes = {
  appointmentStatuses: [...apptTypes, ...completedTypes],
  settlementStatuses: [SettlementStatus.Owing, SettlementStatus.Settled]
};
